// extracted by mini-css-extract-plugin
export default {"icon":"TrackYourIncome_icon__yQYCX","content":"TrackYourIncome_content__Yr3WT"};